import styled from "styled-components";
import {
  Box,
  TitleComponent,
  CustomTable,
  CustomCard,
  NoData,
} from "ui-components";
import { HorizontalCard, Amount, Label } from "../../components/common";
import { CompanyType, FinancialT, FundingRoundT } from "ui-io/company-io";
import { Card } from "@blueprintjs/core";
import { calculateFundingAmount, getInvestorCount } from "../../utils";
import { TableComponent } from "../../components";
import * as t from "io-ts";
import moment from "moment";
import { formatLargeNumber, getCurrencySymbol } from "ui-lib";
import { useQuery } from "react-query";
import { getInvestorsById } from "ui-io/queries/get-investors-by-id";
import ValueWithSkeleton from "../../components/common/value-with-skeleton";
import { useMemo } from "react";
import UnderDevelopment from "../../components/shared/under-development";
type Props = {
  currentCompany?: CompanyType;
};
const FinancingTableColumnIdIO = t.union([
  t.literal("date"),
  t.literal("stage"),
  t.literal("amount"),
  t.literal("investorIDs"),
]);
type FinancingTableColumnIdT = t.TypeOf<typeof FinancingTableColumnIdIO>;
const CompanyFinancing = (props: Props) => {
  const { currentCompany } = props;
  const financials: FinancialT[] = currentCompany?.financials
    ? currentCompany.financials
    : [];

  // if (!financials?.length) return <NoData description={"No available data till this period."}/>;
  // if (financials?.length && financials[0]?.netProfit)
  //   console.log(
  //     "currentCompany=========",
  //     formatLargeNumber(financials[0]?.netProfit),
  //   );
  const currencySymbol = getCurrencySymbol(financials[0]?.currency);
  return (
    <>
      <div>
        <TitleComponent>Financials</TitleComponent>
        <Box flexDir="row" justify="between" gap="large" mt={"medium"}>
          {financials?.length ? (
            financials.map((financial) => (
              <HorizontalCard interactive verticle>
                <Box>
                  <StyledLabel>Revenue</StyledLabel> :{" "}
                  <Amount className="fs-16">
                    {financial?.revenue
                      ? `${currencySymbol} ${formatLargeNumber(financial.revenue)}`
                      : "N/A"}
                  </Amount>
                </Box>
                <Box>
                  <StyledLabel>Net Profit</StyledLabel> :{" "}
                  <Amount className="fs-16">
                    {financial?.netProfit
                      ? `${currencySymbol} ${formatLargeNumber(financial.netProfit)}`
                      : "N/A"}
                  </Amount>
                </Box>

                <Box>
                  <StyledLabel>CashFlow</StyledLabel> :{" "}
                  <Amount className="fs-16">
                    {financial?.cashFlow
                      ? `${currencySymbol} ${formatLargeNumber(financial.cashFlow)}`
                      : "N/A"}
                  </Amount>
                </Box>

                <Box>
                  <StyledLabel>Assets</StyledLabel> :{" "}
                  <Amount className="fs-16">
                    {" "}
                    {financial?.assets
                      ? `${currencySymbol} ${formatLargeNumber(financial.assets)}`
                      : "N/A"}
                  </Amount>
                </Box>

                <Box>
                  <StyledLabel>Liabilities</StyledLabel> :{" "}
                  <Amount className="fs-16">
                    {financials?.length &&
                    financials[0]?.liabilities !== undefined
                      ? `${currencySymbol} ${formatLargeNumber(financials[0].liabilities)}`
                      : "N/A"}
                  </Amount>
                </Box>

                {/* 6. Statement Date Box */}
                <Box>
                  {financials?.length && financials[0]?.date
                    ? financials[0].date
                    : "N/A"}
                </Box>
                <StyledLabel>Funding Rounds</StyledLabel>
              </HorizontalCard>
            ))
          ) : (
            <Box width={"1"}><NoData description={"No available data till this period."} /></Box>
          )}
        </Box>
      </div>
    </>
  );
};

export default CompanyFinancing;

const StyledLabel = styled(Label)`
  white-space: nowrap;
`;
